import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiInstagram, FiFacebook, FiMail } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-luma-sage/30 pt-20 pb-10 border-t border-luma-sand/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          <div className="md:col-span-1">
            <Link to="/" className="font-serif text-2xl mb-4 block">LumaBaby Co.</Link>
            <p className="text-sm text-luma-text/80 leading-relaxed mb-6">
              Tender essentials for your little one's first chapters. Safe, sustainable, and crafted with love.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-luma-text/60 hover:text-luma-primary"><SafeIcon icon={FiInstagram} /></a>
              <a href="#" className="text-luma-text/60 hover:text-luma-primary"><SafeIcon icon={FiFacebook} /></a>
              <a href="#" className="text-luma-text/60 hover:text-luma-primary"><SafeIcon icon={FiMail} /></a>
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Shop</h4>
            <ul className="space-y-3 text-sm text-luma-text/80">
              <li><Link to="/" className="hover:text-luma-primary">Newborn Essentials</Link></li>
              <li><Link to="/" className="hover:text-luma-primary">Nursery & Decor</Link></li>
              <li><Link to="/" className="hover:text-luma-primary">Bath & Skincare</Link></li>
              <li><Link to="/" className="hover:text-luma-primary">Parent Gift Bundles</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Support</h4>
            <ul className="space-y-3 text-sm text-luma-text/80">
              <li><Link to="/" className="hover:text-luma-primary">Shipping & Returns</Link></li>
              <li><Link to="/" className="hover:text-luma-primary">Track Order</Link></li>
              <li><Link to="/" className="hover:text-luma-primary">FAQ</Link></li>
              <li><Link to="/" className="hover:text-luma-primary">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Join Our Village</h4>
            <p className="text-sm text-luma-text/80 mb-4">Subscribe for gentle parenting tips, new arrivals, and 10% off your first order.</p>
            <form className="flex">
              <input 
                type="email" 
                placeholder="Email address" 
                className="bg-white border border-luma-sand px-4 py-2 text-sm w-full focus:outline-none focus:border-luma-primary rounded-l-md"
              />
              <button 
                type="button"
                className="bg-luma-primary text-white px-4 py-2 text-sm hover:bg-luma-primary/90 transition-colors rounded-r-md"
              >
                Join
              </button>
            </form>
          </div>

        </div>
        
        <div className="text-center text-xs text-luma-text/50 pt-8 border-t border-luma-sand/50">
          <p>&copy; {new Date().getFullYear()} LumaBaby Co. All rights reserved. Designed for gentle beginnings.</p>
        </div>
      </div>
      <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
    </footer>
  );
};

export default Footer;